/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Общий вид баннеров
   */
  app.ChponkCommonView = app.View.extend({
    el: 'body',
    chponckSelector: '.chponck-item',
    chponckPackSelector: '.chponk-item-pack',
    additionalOptions: ['mainWindow', 'eventBus', 'chponckSelector', 'chponckPackSelector'],
    /**
     * @inheritDoc
     */
    run: function () {
      this.childViews.banners = [];
      this.childViews.packs = [];
      $('.b-home-chponck').stop(true).delay(200).animate({
        opacity: 1
      }, 400);
      $('.wait-sec-pls').stop(true).delay(200).animate({
        opacity: 0
      }, 400);
      var $chponcksAndPacks = this.$([]);
      if (this.chponckSelector) {
        var chponckSelector = this.chponckSelector;
        if (this.chponckPackSelector) {
          chponckSelector = ':not(' + this.chponckPackSelector + ') > ' + chponckSelector;
        }
        $chponcksAndPacks = $chponcksAndPacks.add(chponckSelector);
      }
      if (this.chponckPackSelector) {
        $chponcksAndPacks = $chponcksAndPacks.add(this.chponckPackSelector);
      }
      if ($chponcksAndPacks.length) {
        // для каждого баннера создаём свой объект
        $chponcksAndPacks.each(function (index, item) {
          var $item = $(item),
            pushTo,
            options,
            ChponckConstructor;
          if ($item.is(this.chponckSelector)) {
            pushTo = this.childViews.banners;
            options = {
              el: $item,
              mainWindow: this.mainWindow,
              eventBus: this.eventBus,
            };
            ChponckConstructor = app.ChponkView;
          }
          if ($item.is(this.chponckPackSelector)) {
            pushTo = this.childViews.packs;
            options = {
              el: $item,
              mainWindow: this.mainWindow,
              eventBus: this.eventBus,
              chponckSelector: this.chponckSelector,
            };
            ChponckConstructor = app.ChponkPackView;
          }
          pushTo && options && ChponckConstructor && pushTo.push(new ChponckConstructor(options));
        }.bind(this));
      }

      // следим за переключением табов на главной
      this.listenTo(this.eventBus, 'tabs.home.change', this.changeWindow);
    },
    /**
     * Из-за эффектов появления баннер занимает свою позицию не сразу.
     *
     * Код ниже реагирует на событие `window.scroll` и определяет попадает ли
     * баннер в поле видимости посетителя.
     */
    changeWindow: function () {
      var that = this;
      setTimeout(function () {
        that.mainWindow.trigger('window.scroll', window);
      }, 100);
    }
  });
})();

}.call(window));